export default __webpack_public_path__ + "static/media/MaskGroup315.99601734.png";